import { httpGet, httpPost } from "@/request/http";

let path = "/giveRecords";

export default {
  getPages(dTO) {
    return httpGet(`${path}/pages`, dTO);
  },
  getCustomers(dTO) {
    return httpGet(`${path}/customers/pages`, dTO);
  },
  getCustomerByValid(items) {
    return httpPost(`${path}/eligibleCustomers/pages`, items);
  },
  save(item) {
    return httpPost(`${path}/batch`, item);
  },
  void(id, item) {
    return httpPost(`${path}/${id}/void`, item);
  },
};
